import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "./api";

const AuthCtx = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("mep_token");
    if (!token) {
      setUser(null);
      setLoading(false);
      return null;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      return data;
    } catch {
      localStorage.removeItem("mep_token");
      setUser(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("mep_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const register = async (email, password, sessionId = null) => {
    const body = { email, password };
    if (sessionId) body.session_id = sessionId;
    const { data } = await api.post("/auth/register", body);
    localStorage.setItem("mep_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const acceptInvitation = async (token, password) => {
    const { data } = await api.post("/auth/invitation/accept", { token, password });
    localStorage.setItem("mep_token", data.token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem("mep_token");
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, loading, login, register, acceptInvitation, logout, refresh, setUser }}>
      {children}
    </AuthCtx.Provider>
  );
};

export const useAuth = () => useContext(AuthCtx);
